var React = require('react');

function RoundCheckBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40 20.5C40 9.4543 31.0457 0.5 20 0.5C8.9543 0.5 0 9.4543 0 20.5C0 31.5457 8.9543 40.5 20 40.5C31.0457 40.5 40 31.5457 40 20.5ZM31.1111 16.0649L27.9684 12.9222L17.7778 23.1444L13.1427 18.4684L10 21.6111L17.7778 29.3889L31.1111 16.0649Z","fill":"#19B459"}));
}

RoundCheckBig.defaultProps = {"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none"};

module.exports = RoundCheckBig;

RoundCheckBig.default = RoundCheckBig;
